/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Text, Button, Stack} from '@chakra-ui/react'
import StyledContent from '../../styled-content'
import {SearchIcon} from '../../icons'

const Suggestions = ({suggestions, closeAndNavigate, searchBarPosition}) => {
    if (!suggestions) {
        return null
    }
    return (
        <Stack spacing={6} data-testid="sf-suggestion">
            {suggestions.map((suggestion, idx) => (
                <Button
                    width="full"
                    height="full"
                    onMouseDown={() =>
                        closeAndNavigate(suggestion.hybrid, suggestion.link, {
                            search_bar_position: searchBarPosition,
                            flyout_section: 'Phrases',
                            flyout_selection: suggestion.name
                        })
                    }
                    fontSize={'md'}
                    key={idx}
                    marginTop={0}
                    variant="menu-link"
                    padding={0}
                    maxWidth="auto"
                    whiteSpace="normal"
                    textAlign="left"
                    leftIcon={<SearchIcon boxSize={4} color="stokkeGray.dark" />}
                >
                    <StyledContent as={Text} content={suggestion.name} fontWeight="400" />
                </Button>
            ))}
        </Stack>
    )
}

Suggestions.propTypes = {
    suggestions: PropTypes.array,
    closeAndNavigate: PropTypes.func,
    searchBarPosition: PropTypes.string
}

export default Suggestions
